import React from 'react';
import { SearchSection, SearchSectionProps } from './SearchSection';
import { TableManagementWrapperStyled } from './styles';

interface Props extends SearchSectionProps {
  headerSection: React.ReactNode;
}

export const CollectionManagementHeader: React.FC<Props> = ({
  headerSection,
  elementsPerPage,
  currentElements,
  elementsTitle,
  totalElements,
  page,
  onSearch,
  searchInputPlaceholder,
}) => {
  return (
    <TableManagementWrapperStyled>
      <SearchSection
        elementsTitle={elementsTitle}
        page={page}
        elementsPerPage={elementsPerPage}
        currentElements={currentElements}
        totalElements={totalElements}
        onSearch={onSearch}
        searchInputPlaceholder={searchInputPlaceholder}
      />
      {headerSection}
    </TableManagementWrapperStyled>
  );
};
